import React from 'react';

const SubListAddress = ({
                            addressArrProps,
                            chooseAddressFuncProps
                        }) => {
    let i = 1
    return (
        <ul className="subListAddress">
            {addressArrProps && !!addressArrProps.length && addressArrProps.map(el => <li className='subListAddress__item'
                                                                       id={el.id} key={++i * 2 + 1000000}
                                                                       onClick={chooseAddressFuncProps}>{el.address.display_name}</li>)}
        </ul>
    )
}

export default SubListAddress;